import { Drawer } from "@made-people/blueprint-drawer";
import { Cross } from "../../../assets/icons/Cross";
import { useIsDesktop } from "../hooks/use-is-desktop";

type AuthDrawerProps = {
  overlayId: string;
  heading: string;
  children: React.ReactNode;
};

export const AuthDrawer = ({
  overlayId,
  heading,
  children,
}: AuthDrawerProps) => {
  const isDesktop = useIsDesktop();

  return (
    <Drawer
      customOverlayId={overlayId}
      direction={isDesktop ? "right" : "bottom"}
      hasHandle={!isDesktop}
      hasScaledBackground={true}
      header={
        isDesktop
          ? {
              closeIcon: <Cross className="w-4 h-4 fill-black" />,
              headingSettings: {
                heading,
                headingTag: "h2" as const,
                variants: { headingSize: "xs" },
              },
            }
          : undefined
      }
    >
      <Drawer.Content
        contentSettings={{
          className: isDesktop ? "w-[477px]" : undefined,
        }}
      >
        <div className="overflow-y-auto pb-8 pt-8">{children}</div>
      </Drawer.Content>
    </Drawer>
  );
};
